import { createClient } from "tinacms/dist/client";
import { queries } from "./types.js";
export const client = createClient({ cacheDir: "/vercel/path0/tina/__generated__/.cache/1790683481609", url: "https://content.tinajs.io/3.0/content/43df56f8-f91f-4c3d-ab57-cc99b7c6512b/github/main", token: "8fe1c9dc350a2fb0f8ac6ac2ed96633b2ded80c4", queries });
export default client;
